import React from 'react'

import { NotFoundPageContent } from '@/components/notFoundPageContent/NotFoundPageContent'
import { MainLayoutV2 } from '@/layouts/MainLayoutV2'
import { Footer } from '@/layouts/AppLayout/Footer/Footer'
import { notFoundPageFooterContainer } from '@/components/notFoundPageContent/NotFoundPageContent.css'

const Custom404Page = () => {
  return <NotFoundPageContent />
}

const PageLayout = (page) => {
  // This can't be tested locally in dev due to
  // https://github.com/vercel/next.js/issues/44293
  return (
    <MainLayoutV2 title="Creatorland | Not Found">
      <div style={{ height: '100vh' }}>
        {page}
        <div className={notFoundPageFooterContainer}>
          <Footer />
        </div>
      </div>
    </MainLayoutV2>
  )
}
Custom404Page.getLayout = PageLayout
export default Custom404Page
